import { Button, Stack, Typography } from "@mui/material";
import WushCard from "../../layout/WushCard";
import { useState } from "react";
import CustomerForm from "../../form/customer/CustomerForm";
import useCustomerStore from "../../../stores/useCustomerStore";

export default function CustomerCard({ customer }) {
  const { customerById } = useCustomerStore();
  const stateCustomer = customerById(customer.id);

  const [ editing, setEditing ] = useState(false);

  if(!stateCustomer) return null;

  return (
    <Stack>
      <WushCard>
        {editing ? <Stack p={2}>
            <CustomerForm customer={stateCustomer} afterUpdate={() => setEditing(false)} onCancel={() => setEditing(false)} />
          </Stack>
        :
          <Stack p={2}>
            <Stack>
              <Stack>
                <Typography variant="h5">{stateCustomer.full_name}</Typography>
              </Stack>
              <Stack>
                <Typography variant="body1">{stateCustomer.email}</Typography>
              </Stack>
              <Stack>
                <Typography variant="body1">{stateCustomer.phone}</Typography>
              </Stack>
              <Stack direction="row">
                <Button onClick={() => setEditing(!editing)} color="primary">Edit Customer Information</Button>
              </Stack>
            </Stack>
          </Stack>
        }
      </WushCard>
    </Stack>
  );
}